import React from 'react'
import { Flex, Text } from '@leverege/ui-elements'

import S from './FieldErrorsComponent.css'

export default function FieldErrorsComponent( { errors } ) {
  let style = null

  if ( errors ) {
    style = {
      height : `${errors.length}em`
    }
  }

  return (
    <Flex
      className={S.errorText}
      style={style}
      variant="colS">
      {errors?.map( ( error ) => {
        if ( typeof error === 'string' ) {
          return (
            <Text
              key={error}
              variant="inputCaptionSmallError">
              {error}
            </Text>
          )
        }

        return null
      } )}
    </Flex>
  )
}
